import Div from './style'

interface IUnauthorizedProps {
  children?: JSX.Element[] | JSX.Element | string
}

export default function Unauthorized(props: IUnauthorizedProps) {
  const { children } = props

  return <Div {...props}>{children}</Div>
}
